<template>
  <div>
    <cp-show-more-list
      v-for="filter in filtersMetadata"
      :key="filter.key"
      class="filter-list"
      :items="availableFilters[filter.key]"
      :style="{ opacity: disabledFilters.includes(filter.key) ? 0.5 : null }"
      @collapse="$emit('listcollapse')"
    >
      <template #title>
        <header class="filter-title">
          {{ filter.label }}

          <template v-if="value[filter.key].length !== 0"> ({{ value[filter.key].length }}) </template>
        </header>
      </template>

      <template #default="{ item }" class="filter-item">
        <cp-checkable-item
          type="checkbox"
          class="filter-item"
          v-model="passThroughValue[filter.key]"
          :value="item.value"
          :disabled="disabledFilters.includes(filter.key)"
        >
          {{ item.label }}
        </cp-checkable-item>
      </template>

      <template #more-label>
        <cp-unstyled-button link>
          <strong>+ More {{ filter.moreFewerLabel }}</strong>
        </cp-unstyled-button>
      </template>

      <template #fewer-label>
        <cp-unstyled-button link>
          <strong>- Fewer {{ filter.moreFewerLabel }}</strong>
        </cp-unstyled-button>
      </template>
    </cp-show-more-list>
  </div>
</template>

<script>
import CpCheckableItem from './checkable-item';
import CpExpander from '../expander';
import CpShowMoreList from './show-more-list';
import CpUnstyledButton from '../unstyled-button';
import filtersMetadata from './filters-metadata';

export default {
  components: {
    CpCheckableItem,
    CpExpander,
    CpShowMoreList,
    CpUnstyledButton,
  },

  props: ['value', 'availableFilters'],

  data() {
    return {
      filtersMetadata,
    };
  },

  computed: {
    passThroughValue: {
      get() {
        return this.value;
      },

      set(passThroughValue) {
        this.$emit('input', passThroughValue);
      },
    },

    disabledFilters() {
      return this.filtersMetadata.filter(filter => filter.isDisabled(this.value)).map(filter => filter.key);
    },
  },

  watch: {
    disabledFilters(disabledFilters) {
      disabledFilters.forEach(filter => (this.value[filter] = []));
    },
  },
};
</script>

<style scoped>
.filter-title {
  font-weight: bold;
}

.filter-list {
  margin: 15px 0;
}

.filter-item {
  padding: 3px 0;
}
</style>
